module.exports = __webpack_public_path__ + "images/astonmartin78d69eeeafc9cb9897a314e95b1ce5e3.png";